export enum ERROR {
    NOT_FOUND = 'NOT_FOUND',
    CACHED = 'CACHED'
}

export interface OptionType {
    value: string;
    label: string;
}

export interface SpecialityNiche {
    id: number;
    name: string;
    children: {
        id: number;
        name: string
    }[]
}

export interface Master {
    gender_list: Record<string, string>;
    niche_list: Record<string, string>;
    age_group_list: string[],
    language_list: Record<string, string>,
    speciality_niches: SpecialityNiche[],
    partner?: Partner
}

export interface Partner {
    logo_url?: string | null,
    menu_style?: string | null,
}

export interface Address {
    name: string,
    city: string,
    region: string,
    sublocality: string,
    pincode: string,
    premise: string,
    lat: number,
    lng: number,
    place_id?: string
}

export interface SavedAddress extends Address {
  id: string
  uuid: string
}

export interface Currency {
    code: string;
    symbol: string;
    locale: string;
}

export interface Timezone {
    id: number;
    iana_code: string;
    name: string;
    utc_offset: number;
}